/** AI-assistant preview opt-in. Reveals the unified AI lane for one visitor via a
 *  `?ai-preview=<AI_PREVIEW_TOKEN>` magic link, WITHOUT touching the global
 *  chat-preview opt-in (`lib/chat-preview.ts`). Mirrors its cookie pattern. */
export const AI_PREVIEW_TOKEN_COOKIE = "ai-preview"
export const AI_PREVIEW_ACTIVE_COOKIE = "ai-preview-active"
export const AI_PREVIEW_PARAM = "ai-preview"

/** True when the visitor opted into the AI-lane preview. Client-only — reads
 *  `document.cookie`, returns false during SSR so it never forces a page dynamic. */
export function hasAiPreviewActive(): boolean {
  if (typeof document === "undefined") return false
  return document.cookie.split("; ").includes(`${AI_PREVIEW_ACTIVE_COOKIE}=1`)
}
